module.exports = __webpack_public_path__ + "static/media/2019_4G8A5954.ae699c23.jpg";